module.exports = __webpack_public_path__ + "static/media/world-tour.1aa57923.jpg";